import React, { useEffect, useState } from "react";
import ModalWindow from "../../shared/ModalWindow";

import style from "./style.module.scss";
import OrdersLocationInfo from "./index";
import OrdersSectionItemInfoColumn from "../section-item/components/OrdersSectionItemInfoColumn";
import SelectCustom from "../../shared/forms/select-custom";
import InputCustom from "../../shared/forms/input-custom";
import InputSearch from "../../shared/forms/input-search";
import { Order, User } from "../../../services";
import InputMask from "react-input-mask";
import cn from "classnames";
import { toast } from "react-toastify";
import Loading from "../../shared/Loading/Loading";
import { get } from "../../../services/config";
import { useSelector } from "react-redux";
import { requestErrorDisplay } from "../../../utils";
import CustomSelect from "../../custom/custom-select";
import CustomInput from "../../custom/custom-input/CustomInput";
import AddAddress from "./components/AddAddress";
import {t} from "i18next";

const OrdersLocationAddModal = ({
  onClose,
  updateContent,
  searchText = "",
  titleEnd = "",
  displayBin = false,
  isSender = false,
  setLoadingAddress = false,
  countries = [],
  countrySelected,
  citySelected,
  onChangeCity,
  onChangeCountry,
}) => {
  const { user } = useSelector((state) => state);
  const [name, setName] = useState(null);
  const [country, setCountry] = useState(countrySelected);
  const [binData, setBinData] = useState();
  const [cities, setCities] = useState();
  const [city, setCity] = useState(citySelected);
  const [address, setAddress] = useState(searchText || null);
  const [coordinates, setCoordinates] = useState();
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  useEffect(() => {
    if (user?.id && isSender) {
      setPhone(user?.phoneNumber || null);
    }
    setEmail(user?.email || null);
  }, [user, isSender]);

  useEffect(() => {
    if (country?.id) {
      Order.getCities(country.id)
        .then((response) => {
          console.log("cities 111", country, response);
          setCities(
            response.data.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            }),
          );
        })
        .catch((error) => {
          console.log(error);
          toast.error(error);
        });
    } else {
      setCities([]);
    }
  }, [country]);

  const getInfoByBin = async (bin) => {
    try {
      const { data } = await get(`/v1/users/gov/juridical`, {
        params: {
          bin,
          lang: "ru",
        },
      });
      if (!data.success) {
        throw data;
      }
      setBinData(data.obj);
      setName(data?.obj?.name);
    } catch (e) {
      console.log("error", e);
    }
  };

  const validationData = () => {
    setErrors(null);
    const newErrors = {};
    let allow = true;

    if (!isSender && !name) {
      toast.error('Заполните поле "Название организации получателя"');
      newErrors.name = "Введите название";
      allow = false;
    }
    if (!phone) {
      toast.error('Заполните поле "Контактный телефон"');
      newErrors.phone = "Введите телефон";
      allow = false;
    }
    if (!coordinates) {
      toast.error('Координаты не получены, попробуйте еще раз выбрать адрес из справочника');
      newErrors.address = "Укажите точный адрес(улица, дом...)";
      allow = false;
    }
    if (!address) {
      toast.error('Заполните поле "Адрес"');
      newErrors.address = "Укажите точный адрес(улица, дом...)";
      allow = false;
    }
    if (!country?.id) {
      toast.error('Заполните поле "Страна"');
      newErrors.country = "Заполните данные";
      allow = false;
    }
    if (!city?.id) {
      toast.error('Заполните поле "Город"');
      newErrors.city = "Заполните данные";
      allow = false;
    }

    setErrors(newErrors);
    return allow;
  };

  const submitHandle = () => {
    if (!validationData()) {
      return;
    }

    const formData = {
      countryId: country?.id,
      cityId: city?.id,
      phoneNumber: phone.replace("+", ""),
      email: email,
      fullAddress: address,
      latLng: coordinates,
    };
    if (isSender) {
      formData["type"] = 0;
    } else {
      formData["type"] = 1;
      formData["name"] = name;
    }

    setLoading(true);
    Order.getUserAddressCreate(formData)
      .then((res) => res.data)
      .then((response) => {
        toast.info("Запись успешно создан");
        updateContent(response);
        console.log("submit", country, response);
      })
      .catch((error) => {
        requestErrorDisplay(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const startSearch = (bin) => {
    if (bin.length === 12) {
      getInfoByBin(bin);
    } else {
      setBinData(null);
    }
  };

  return (
    <ModalWindow onClose={onClose} style={{ marginTop: "210px" }}>
      <div className={style.modal}>
        <h3>{t('addAddress')} {titleEnd}</h3>
        {/* Bin */}
        {displayBin && (
          <>
            <OrdersSectionItemInfoColumn>
              <CustomInput
                labelText={t('recipientOrganizationName')}
                placeholder={t('writeName')}
                isBgGray
                value={name}
                onChangeValue={setName}
                errorText={errors?.name}
              />
            </OrdersSectionItemInfoColumn>
          </>
        )}

        <OrdersSectionItemInfoColumn>
          <CustomSelect
            labelText={t('ordersCreate.view.label.country')}
            placeholder= {t('common.placeholder.selectOption')}
            options={countries}
            defaultValue={country}
            onSubmit={(country) => {
              setCountry(country);
              setCity(null);
              onChangeCountry(country);
            }}
            errorText={errors?.country}
            returnObject
          />
        </OrdersSectionItemInfoColumn>

        <OrdersSectionItemInfoColumn>
          <CustomSelect
            key={city?.id}
            labelText={t('ordersCreate.view.label.city')}
            placeholder={t('common.placeholder.selectOption')}
            options={cities}
            defaultValue={city}
            onSubmit={(city) => {
              setCity(city);
              onChangeCity(city);
            }}
            isDisabled={!country}
            errorText={errors?.city}
            returnObject
          />
        </OrdersSectionItemInfoColumn>

        <OrdersSectionItemInfoColumn>
          <AddAddress
            labelText={t('address')}
            placeholder={t('writeAddress')}
            setAddress={setAddress}
            errorText={errors?.address}
            isDisabled={!city}
            country={country?.name || ""}
            city={city?.name || ""}
            address={address || ""}
            setCoordinates={setCoordinates}
            setLoadingAddress={setLoadingAddress}
          />
        </OrdersSectionItemInfoColumn>

        <OrdersSectionItemInfoColumn>
          <CustomInput
            labelText={t('contactNumber')}
            placeholder={t('addContactNumber')}
            inputType="text"
            isBgGray
            value={phone}
            isPhone
            onChangeValue={setPhone}
            errorText={errors?.phone}
          />
        </OrdersSectionItemInfoColumn>

        <OrdersSectionItemInfoColumn>
          <CustomInput
            labelText={t('optionalEmail')}
            placeholder={t('login.emailPlaceholder')}
            inputType="text"
            onChangeValue={setEmail}
            value={email}
            errorText={errors?.email}
            isBgGray
          />
        </OrdersSectionItemInfoColumn>

        <button
          type="button"
          className={cn(style.modal_button, {
            [style.modal_button_disabled]: !country || !city,
          })}
          onClick={submitHandle}
        >
          {isLoading ? <Loading inBlock marginBottom={0} /> : t('saveAddress')}
        </button>
      </div>
    </ModalWindow>
  );
};

export default OrdersLocationAddModal;
